module.exports = __webpack_public_path__ + "img/Anhänger_Lichtmast.aabe4396.svg";